module.exports = __webpack_public_path__ + "static/media/FUEL-BNB.b7efd51d.svg";